import { Toast } from '@adc/parallax-component-library';
import { createRootRoute, Outlet } from '@tanstack/react-router';

import { Header } from '~/components/navigation/Header';
import { NotFoundRoute } from '~/components/NotFoundRoute';
import { PageContainer } from '~/components/PageContainer';
import { ModalProvider } from '~/features/modals/ModalProvider';
import { useDevToolsSetting } from '~/features/settings/devTools';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundRoute,
});

const ROOT_STACK_ID = 'root-stack';

function RootComponent() {
  const { isDevToolsEnabled } = useDevToolsSetting();

  return (
    <ModalProvider>
      <Header />

      <PageContainer id={ROOT_STACK_ID}>
        <Outlet />
        <Toast testID="toast" bottomMargin={isDevToolsEnabled ? 100 : 60} />
      </PageContainer>
    </ModalProvider>
  );
}
